document.addEventListener('DOMContentLoaded', function() {
  /* V2 — Capture-phase, window-level submit interceptor for cart-add
     forms. Earlier we registered on each form's submit listener at the
     bubble phase — but udesly-shopify.min.js ALSO registers its own
     handler at the same scope and posts to /cart/add.js, causing a
     duplicate add (one of the two would race-fail with a 422 and
     trigger our "no longer available" popup even though the cart
     actually got the item). Registering on `window` at capture phase
     means our handler runs BEFORE any form-level listener; calling
     `stopImmediatePropagation()` then prevents udesly's handler from
     firing at all. We do the add ourselves in handleCartAddSubmit. */
  window.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form || !form.matches || !form.matches('form[action="/cart/add"]')) return;
    ev.preventDefault();
    ev.stopPropagation();
    ev.stopImmediatePropagation();
    handleCartAddSubmit(form);
  }, true);

  function handleCartAddSubmit(form) {
      const submitButton = form.querySelector('input[type="submit"]');
      const quantityInput = form.querySelector('.quantity-input');
      const quantity = quantityInput ? parseInt(quantityInput.value) : 1;

      submitButton.disabled = true;
      submitButton.value = 'Adding...';

      // Canonical add (fires Meta AddToCart + reconciles /cart.js + cart:change + opens drawer).
      window.neswAddToCart(form.querySelector('input[name="id"]').value, quantity, { openDrawer: true })
      .then(() => {
        // openDrawer:true already refreshes the drawer (openCartDrawer -> updateCart),
        // and the add itself dispatched cart:change first — a second updateCart() here
        // was a redundant extra /cart.js round trip on every PDP add (measured).
        // Visual feedback
        submitButton.value = 'Added!';
        setTimeout(() => {
          submitButton.value = 'Add to Cart';
        }, 1500);
      })
      .catch(error => {
        console.error('Error:', error);
        const form = document.querySelector('form[action="/cart/add"]');
        const productTitle = document.querySelector('.product-title') || document.querySelector('.product-1-title');
        const variantSelectors = form.querySelectorAll('.variant-select, .select-field');
        const variantOptions = Array.from(variantSelectors).map(select => select.value).join(' / ');

        // Create and show popup message
        const popup = document.createElement('div');
        popup.className = 'cart-popup-message';

        const popupContent = document.createElement('div');
        popupContent.className = 'cart-popup-content';

        const message = document.createElement('p');
        message.textContent = 'Sorry, ' + (productTitle ? productTitle.textContent : 'this product') + (variantOptions ? ' - ' + variantOptions : '') + ' is no longer available.';

        const okButton = document.createElement('button');
        okButton.textContent = 'OK';
        okButton.addEventListener('click', function() {
          popup.remove();
        });
        okButton.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            popup.remove();
          }
        });

        popupContent.appendChild(message);
        popupContent.appendChild(okButton);
        popup.appendChild(popupContent);
        document.body.appendChild(popup);

        // Focus the OK button for accessibility
        okButton.focus();

        // Add styles for the popup
        const style = document.createElement('style');
        style.textContent = `
          .cart-popup-message {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0,0,0,0.5);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 9999;
          }
          .cart-popup-content {
            background: white;
            padding: 20px;
            border-radius: 4px;
            text-align: center;
            max-width: 90%;
            width: 400px;
          }
          .cart-popup-content button {
            margin-top: 15px;
            padding: 8px 20px;
            background: #000;
            color: white;
            border: none;
            border-radius: 4px;
            cursor: pointer;
          }
          .cart-popup-content button:hover {
            opacity: 0.9;
          }
        `;
        document.head.appendChild(style);

        submitButton.value = 'Add to Cart';
      })
      .finally(() => {
        submitButton.disabled = false;
      });
  }

  // Update color label when a color swatch is clicked
  document.querySelectorAll('.product-color-swatch').forEach(function(swatch) {
    swatch.addEventListener('click', function() {
      var colorName = this.getAttribute('data-color-name');
      var label = this.closest('fieldset').querySelector('.product-color-selected');
      if (label && colorName) {
        label.textContent = colorName;
      }
    });
  });

  // Parse variant data for availability checks
  var variantsData = [];
  var variantsDataEl = document.querySelector('[data-type="product-variations-data"]');
  if (variantsDataEl) {
    try { variantsData = JSON.parse(variantsDataEl.textContent); } catch(e) {}
  }

  // Show/hide the ATC pill vs the SOLD OUT pill based on the selected variant.
  // Notify-me is owned by the Ignis back-in-stock app block (it watches the
  // same [name="id"] input and shows its own button when the variant is OOS);
  // the legacy #variant-bis-section flow was retired 2026-08-07.
  function updateSoldOutUI() {
    var variantInput = document.getElementById('ultimate-selected-variant');
    if (!variantInput || variantsData.length === 0) return;

    var selectedVariant = variantsData.find(function(v) { return v.id === variantInput.value; });
    /* Act only on POSITIVE knowledge. An id we can't resolve in the variant
       JSON is an absence, not a sold-out signal — claiming "Sold out" on a
       lookup miss is how a ghost pill appears on an in-stock product. Leave
       the server-rendered state alone until the id resolves. */
    if (!selectedVariant) return;
    var isAvailable = selectedVariant.available;

    /* Header price follows the selected variant (2026-09-04). The framework's
       own h5 rewrite silently fails on products whose options are not
       (Color, Size) — on the tee bundle (Pack Size, Size, Color) switching
       3-Pack/4-Pack left the old price at the top while the ATC button showed
       the right one. variantsData prices are server-formatted (money filter);
       markup mirrors nesw-sale-price: struck compare first, then the price. */
    var priceH5 = document.getElementById('product-price-section-2');
    if (priceH5 && selectedVariant.price) {
      while (priceH5.firstChild) priceH5.removeChild(priceH5.firstChild);
      priceH5.appendChild(document.createTextNode(selectedVariant.price.replace('.00', '')));
      if (selectedVariant.compare_at_price) {
        priceH5.appendChild(document.createTextNode(' '));
        var cmp = document.createElement('del');
        cmp.textContent = selectedVariant.compare_at_price.replace('.00', '');
        cmp.style.cssText = 'color:#8a8a8a;font-weight:400;margin-left:2px;';
        priceH5.appendChild(cmp);
      }
    }

    var quantitySelector = document.querySelector('.quantity-selector');
    var addToCartBtn = document.querySelector('.add-to-cart-button');
    /* V2 — Hide the entire joined ATC pill (button + bookmark) when
       the selected variant is sold out. Hiding only the ATC input
       left the bookmark stranded floating in the empty pill space at
       the top-left of the OOS bar. */
    var atcPillWrap = document.querySelector('.nesw-atc-pill-wrap');
    var oosStatic = document.getElementById('variant-oos-static');
    /* A delivery date is a promise about something you can actually buy, so the
       expected-delivery line rides this switch rather than the page. Only ever
       re-shown when the section's own script marked it 'ready', which is its
       record that the shopper is in the market the window is true for. */
    var etaNote = document.querySelector('[data-nesw-eta]');

    if (isAvailable) {
      // Show add to cart, hide sold out
      if (quantitySelector) quantitySelector.style.display = '';
      if (atcPillWrap) { atcPillWrap.style.display = ''; atcPillWrap.classList.add('is-pdp-ready'); }
      if (addToCartBtn) { addToCartBtn.style.display = ''; addToCartBtn.disabled = false; addToCartBtn.value = 'Add to Cart'; }
      if (oosStatic) { oosStatic.style.display = 'none'; oosStatic.classList.remove('is-pdp-ready'); }
      if (etaNote && etaNote.getAttribute('data-nesw-eta') === 'ready') etaNote.hidden = false;
    } else {
      // Hide add to cart, show the sold-out pill
      if (quantitySelector) quantitySelector.style.display = 'none';
      if (atcPillWrap) { atcPillWrap.style.display = 'none'; atcPillWrap.classList.remove('is-pdp-ready'); }
      if (addToCartBtn) addToCartBtn.style.display = 'none';
      if (oosStatic) { oosStatic.style.display = ''; oosStatic.classList.add('is-pdp-ready'); }
      if (etaNote) etaNote.hidden = true;
    }
  }

  /* V2 — Repaint the LOW STOCK badge for the currently-selected variant.
     The badge is Liquid-rendered for the first variant only; without this,
     switching color/size leaves a stale badge (either showing when it
     shouldn't, or missing when the new variant is actually low stock).
     Reads inventory_quantity/management/policy from variantsData and the
     threshold from `data-low-stock-threshold` on the wrap. */
  function updateLowStockBadge() {
    var wrap = document.querySelector('.nesw-low-stock-wrap');
    if (!wrap) return;
    var input = document.getElementById('ultimate-selected-variant');
    if (!input || variantsData.length === 0) return;
    var v = variantsData.find(function(x) { return x.id === input.value; });
    var threshold = parseInt(wrap.dataset.lowStockThreshold || '5', 10);
    var show = !!(v && v.inventory_management === 'shopify' &&
                  v.inventory_policy === 'deny' &&
                  v.inventory_quantity > 0 &&
                  v.inventory_quantity < threshold);
    var existing = wrap.querySelector('.nesw-low-stock');
    if (existing) existing.parentNode.removeChild(existing);
    if (!show) return;
    var SVG_NS = 'http://www.w3.org/2000/svg';
    var span = document.createElement('span');
    span.className = 'nesw-low-stock';
    span.setAttribute('aria-label', 'Low stock');
    var iconWrap = document.createElement('span');
    iconWrap.className = 'nesw-low-stock__icon-wrap';
    var svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('class', 'nesw-low-stock__icon');
    svg.setAttribute('viewBox', '0 0 12 12');
    svg.setAttribute('aria-hidden', 'true');
    var circle = document.createElementNS(SVG_NS, 'circle');
    circle.setAttribute('cx', '6');
    circle.setAttribute('cy', '6');
    circle.setAttribute('r', '3.5');
    circle.setAttribute('fill', 'currentColor');
    svg.appendChild(circle);
    iconWrap.appendChild(svg);
    span.appendChild(iconWrap);
    var text = document.createElement('span');
    text.className = 'nesw-low-stock__text';
    text.textContent = 'Low stock';
    span.appendChild(text);
    wrap.appendChild(span);
  }

  /* V2 — Resolve availability BEFORE the 150 ms poll interval kicks in,
     so the right pill (ATC or OOS) is the one painted from frame 1.
     Previously the ATC pill was always visible at first paint and JS
     swapped to the OOS pill ~150 ms later, causing the half-second
     flash Jay reported when an OOS variant was the auto-selected one. */
  updateSoldOutUI();
  updateLowStockBadge();

  // Watch for variant changes by polling the hidden input
  var variantInput = document.getElementById('ultimate-selected-variant');
  if (variantInput) {
    var lastVal = variantInput.value;
    setInterval(function() {
      if (variantInput.value !== lastVal) {
        lastVal = variantInput.value;
        updateSoldOutUI();
        updateLowStockBadge();
      }
    }, 150);
  }

  // After udesly initializes
  setTimeout(function() {
    // Fix default color swatch selection
    var defaultColorInput = document.getElementById('default-product-color');
    if (defaultColorInput) {
      var defaultColor = defaultColorInput.value;
      var correctSwatch = document.querySelector('.product-color-swatch[data-option-name="' + defaultColor + '"]');
      if (correctSwatch && !correctSwatch.classList.contains('w--ecommerce-pill-selected')) {
        correctSwatch.click();
      }
    }

    // Sync color label
    var selectedSwatch = document.querySelector('.product-color-swatch.w--ecommerce-pill-selected');
    if (selectedSwatch) {
      var colorName = selectedSwatch.getAttribute('data-color-name');
      var label = selectedSwatch.closest('fieldset').querySelector('.product-color-selected');
      if (label && colorName) label.textContent = colorName;
    }

    // Mark sold-out sizes based on currently selected color
    function updateSizePillAvailability() {
      var sizePills = document.querySelectorAll('.w-commerce-commerceaddtocartoptionpill:not(.product-color-swatch)');
      var selectedColor = '';
      var selectedSwatch = document.querySelector('.product-color-swatch.w--ecommerce-pill-selected');
      if (selectedSwatch) {
        selectedColor = selectedSwatch.getAttribute('data-option-name') || '';
      }

      /* Position-agnostic matcher (2026-09-04): the old logic assumed the
         colour lived at option1, so any product whose options are not
         (Color, ...) — the tee bundle is (Pack Size, Size, Color) — failed
         every match once a swatch was selected and struck out EVERY size on
         a product Shopify itself considers sellable (policy CONTINUE). A
         variant matches when the size appears at ANY position and, if a
         colour is selected, the colour also appears at ANY position. */
      function variantMatches(v, sizeName, colorName) {
        var opts = [v.option1, v.option2, v.option3];
        if (opts.indexOf(sizeName) === -1) return false;
        if (colorName && opts.indexOf(colorName) === -1) return false;
        return v.available;
      }
      sizePills.forEach(function(pill) {
        var sizeName = pill.getAttribute('data-option-name');
        var hasAvailable = variantsData.some(function(v) {
          return variantMatches(v, sizeName, selectedColor);
        });
        if (hasAvailable) {
          pill.classList.remove('size-sold-out');
        } else {
          pill.classList.add('size-sold-out');
        }
      });

      // Remove disabled class so sold-out sizes stay clickable
      document.querySelectorAll('.w-commerce-commerceaddtocartoptionpill.w--ecommerce-pill-disabled:not(.product-color-swatch)').forEach(function(pill) {
        pill.classList.remove('w--ecommerce-pill-disabled');
        if (!pill.classList.contains('size-sold-out')) {
          // Re-check if this should be sold out (same position-agnostic matcher)
          var sizeName = pill.getAttribute('data-option-name');
          var hasAvailable = variantsData.some(function(v) {
            return variantMatches(v, sizeName, selectedColor);
          });
          if (!hasAvailable) pill.classList.add('size-sold-out');
        }
      });
    }

    // Run on page load
    updateSizePillAvailability();

    /* Land the shopper on the best IN-STOCK size instead of udesly's default
       (variant #1 = Small, selected even when sold out). Priority order is
       NESW merchandising policy: L, M, XL, S carry the volume, then the rest.
       Skipped entirely when the shopper arrived via an explicit ?variant=
       deep link (bookmark, back-in-stock email, ad feed). Runs once. */
    function autoSelectPreferredSize() {
      var landing = (typeof window.__neswLandingSearch === 'string') ? window.__neswLandingSearch : '';
      if (/[?&]variant=/.test(landing)) return;
      if (!variantsData.length) return;
      var PRIORITY = ['l', 'm', 'xl', 's', '2xl', 'xs', '3xl'];
      var pills = document.querySelectorAll('.add-to-cart-section .w-commerce-commerceaddtocartoptionpill:not(.product-color-swatch)');
      if (!pills.length) return; /* hats, bundles: no size pills */
      var selectedColor = '';
      var sw = document.querySelector('.product-color-swatch.w--ecommerce-pill-selected');
      if (sw) selectedColor = sw.getAttribute('data-option-name') || '';
      function sizeAvailable(sizeName) {
        return variantsData.some(function (v) {
          if (selectedColor && v.option1 !== sizeName) {
            return v.available && v.option1 === selectedColor && (v.option2 === sizeName || v.option3 === sizeName);
          }
          return v.available && (v.option1 === sizeName || v.option2 === sizeName || v.option3 === sizeName);
        });
      }
      for (var i = 0; i < PRIORITY.length; i++) {
        var size = PRIORITY[i];
        var pill = null;
        for (var j = 0; j < pills.length; j++) {
          if ((pills[j].getAttribute('data-option-name') || '').toLowerCase() === size) { pill = pills[j]; break; }
        }
        if (!pill || !sizeAvailable(size)) continue;
        if (!pill.classList.contains('w--ecommerce-pill-selected')) {
          window.__neswAutoSizing = true;
          pill.click();
          setTimeout(function () { window.__neswAutoSizing = false; }, 0);
        }
        return; /* highest-priority in-stock size handled either way */
      }
      /* nothing in stock: leave udesly's state alone; sold-out UI owns it */
    }
    /* Wait one beat for the default-color swatch fix above to settle
       (it clicks a swatch; udesly needs ~100ms), then pick the size. */
    setTimeout(autoSelectPreferredSize, 200);

    // Re-run when color swatches are clicked
    document.querySelectorAll('.product-color-swatch').forEach(function(swatch) {
      swatch.addEventListener('click', function() {
        // Small delay to let udesly update the selected state
        setTimeout(updateSizePillAvailability, 100);
      });
    });

    // Initial check
    updateSoldOutUI();
    updateLowStockBadge();
  }, 500);

});
